/**
 * Article detail page: builds the "Overview" table of contents from the
 * rich-text body, highlights the section currently in view while
 * scrolling.
 *
 * Section titles are picked up two ways, since Shopify's article editor
 * doesn't guarantee real <h2>/<h3>/<h4> tags - a lot of posts (this
 * theme's included) are written as bold paragraphs instead:
 *   1. Automatically: any actual h2/h3/h4 in the body.
 *   2. Explicitly: any element with class="article-toc-heading" - add this
 *      class (via the article's "Show HTML" / </> source editor in
 *      Shopify admin) to whichever element already holds a section's
 *      title text, e.g. turn
 *        <p><strong>Which products are covered?</strong></p>
 *      into
 *        <p><strong class="article-toc-heading">Which products are covered?</strong></p>
 *      and it becomes an Overview entry with no other markup changes
 *      needed - it still renders identically, just also gets picked up
 *      here.
 *
 * Everything here is progressive enhancement - with JavaScript disabled the
 * article body and contact box all still work exactly as rendered by
 * sections/main-article.liquid.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-article-page]');
  if (!root) return;

  var contentEl = root.querySelector('[data-article-content]');
  var tocBoxEl = root.querySelector('[data-article-toc]');
  var tocListEl = root.querySelector('[data-article-toc-list]');

  var DIACRITIC_MARKS = new RegExp('[' + String.fromCharCode(0x0300) + '-' + String.fromCharCode(0x036f) + ']', 'g');

  function slugify(text) {
    return (
      String(text || '')
        .toLowerCase()
        .normalize('NFKD')
        .replace(DIACRITIC_MARKS, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'section'
    );
  }

  var sections = [];

  if (contentEl && tocBoxEl && tocListEl) {
    // Real heading tags, explicit .article-toc-heading marks, and Shopify
    // bold-only paragraphs (the editor often uses <p><strong>Title</strong></p>
    // instead of an h2). The same title can match more than once (the <p>
    // and the <strong> inside it, or an h2 plus a bold paragraph), so we
    // drop nested matches and consecutive duplicate labels.
    var headingNodes = Array.prototype.slice.call(
      contentEl.querySelectorAll('h2, h3, h4, .article-toc-heading, p:has(> strong:only-child), p:has(> b:only-child)')
    );

    headingNodes = headingNodes.filter(function (el, _i, arr) {
      return !arr.some(function (other) {
        return other !== el && other.contains(el);
      });
    });

    var usedIds = {};
    var lastLabel = '';

    headingNodes.forEach(function (heading) {
      var text = heading.textContent.replace(/\s+/g, ' ').trim();
      if (!text) return;

      var labelKey = text.toLowerCase();
      if (labelKey === lastLabel) return;
      lastLabel = labelKey;

      var baseId = slugify(text);
      var id = baseId;
      var n = 1;
      while (usedIds[id]) {
        id = baseId + '-' + n++;
      }
      usedIds[id] = true;

      if (!heading.id) heading.id = id;
      heading.style.scrollMarginTop = '130px';

      sections.push({ id: heading.id, label: text, el: heading });
    });

    if (sections.length) {
      tocListEl.innerHTML = sections
        .map(function (s) {
          return '<a href="#' + s.id + '" class="article-toc_link" data-article-toc-link="' + s.id + '">' + s.label.replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
          }) + '</a>';
        })
        .join('');
      tocBoxEl.hidden = false;

      var tocLinks = tocListEl.querySelectorAll('[data-article-toc-link]');

      function setActive(id) {
        tocLinks.forEach(function (link) {
          link.classList.toggle('is--active', link.getAttribute('data-article-toc-link') === id);
        });
      }

      setActive(sections[0].id);

      // Clicking an Overview title smooth-scrolls the article body down to
      // that section instead of jumping instantly - heading.style
      // .scrollMarginTop (set above) keeps it clear of the sticky header.
      tocListEl.addEventListener('click', function (event) {
        var link = event.target.closest('[data-article-toc-link]');
        if (!link) return;
        var target = document.getElementById(link.getAttribute('data-article-toc-link'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setActive(link.getAttribute('data-article-toc-link'));
        if (window.history.pushState) {
          window.history.pushState(null, '', '#' + target.id);
        }
      });

      var ticking = false;
      function onScroll() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var active = sections[0].id;
          sections.forEach(function (s) {
            if (s.el.getBoundingClientRect().top <= 160) active = s.id;
          });
          setActive(active);
          ticking = false;
        });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }
})();
